import React from 'react';
import { ensuredForwardRef } from 'react-use';
import { useSpring } from '@react-spring/web';
import * as easings from 'd3-ease';
import { Wrapper, Header, HeaderTitle, Main, InnerWrapper } from './styled';
export const Lightbox = ensuredForwardRef(function Lightbox({ title = 'Lightbox', children, ...rest }, ref) {
    const titleAnimation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: {
            duration: 250,
            easing: easings.easeCubicIn
        }
    });
    const contentAnimation = useSpring({
        from: {
            opacity: 0,
            transform: 'translate3d(0,100%,0)'
        },
        to: {
            opacity: 1,
            transform: 'translate3d(0,0,0)'
        },
        config: {
            duration: 300,
            easing: easings.easeCubicIn
        }
    });
    return (React.createElement(Wrapper, { ref: ref, ...rest },
        React.createElement(Header, null,
            React.createElement(HeaderTitle, { style: titleAnimation }, title)),
        React.createElement(InnerWrapper, null,
            React.createElement(Main, { style: contentAnimation }, children))));
});
